import React from 'react';
import './sectionTitle.css';

const SectionTitle = (props) => {
    return ( 
        <>
        <h3 className='sectionTitle'>{props.secTitle}</h3>
        </>
     );
}
 
export default SectionTitle;